import { render, staticRenderFns } from "./remittance-report.vue?vue&type=template&id=2a0abac5"
import script from "./remittance-report.vue?vue&type=script&lang=js"
export * from "./remittance-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports